import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiConnectionService }  from '../services/core/api-connection.service';
import { ConfigService }  from '../services/core/config.service';

import {Observable} from "rxjs/internal/Observable";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AppService {

  constructor(
	public configService: ConfigService,
	public apiConnectionService: ApiConnectionService
  ) { }
	
  topNavActive = new BehaviorSubject({});
  data = this.topNavActive.asObservable();
  
  pageDocument = new BehaviorSubject({});
  pageDocumentData = this.pageDocument.asObservable();
  
  currentAuthor = new BehaviorSubject({});
  currentAuthorData = this.currentAuthor.asObservable();
  
  activities = new BehaviorSubject({});
  activitiesData = this.activities.asObservable();

  currentOrganisation = new BehaviorSubject({});

  toastList = [];

  toastObservable = new BehaviorSubject({});
  toasts = this.toastObservable.asObservable();
  
  defaultTitle = '';
  defaultDescription = '';

  pageDocumentObject = {
	  topNavActive:'active', 
	  title:'', 
	  description:'', 
	  showPasswordResetModal: false, 
	  showLoginModal: false,
	  isPreview: false,
	  showRegisterModal: false,
	  showCheckRequestAlert: true,
	  tempEmail: ''
  };
  
  navActive () {
	this.pageDocumentObject.topNavActive = 'active';
  	this.pageDocument.next(this.pageDocumentObject);
  }
  
  navInactive () {
	this.pageDocumentObject.topNavActive = 'inactive';
  	this.pageDocument.next(this.pageDocumentObject);
  }
  
  showLoginModal (isPreview = false) {
	this.hideRegisterModal ();
	this.pageDocumentObject.showLoginModal = true;
	this.pageDocumentObject.isPreview = isPreview;
  	this.pageDocument.next(this.pageDocumentObject);
  }
  
  hideLoginModal () {
	this.pageDocumentObject.showLoginModal = false;
  	this.pageDocument.next(this.pageDocumentObject);
  }
  
  showRegisterModal () {
	this.hideLoginModal();
	this.pageDocumentObject.showRegisterModal = true;
  	this.pageDocument.next(this.pageDocumentObject);
  }
  
  hideRegisterModal () {
	this.pageDocumentObject.showRegisterModal = false;
  	this.pageDocument.next(this.pageDocumentObject);
  }
  
  showPasswordResetModal (email) {
	this.pageDocumentObject.showLoginModal = false;
	this.pageDocumentObject.showPasswordResetModal = true;
	this.pageDocumentObject.tempEmail = email;
  	this.pageDocument.next(this.pageDocumentObject);
  }
  
  hidePasswordResetModal () {
	this.pageDocumentObject.showPasswordResetModal = false;
  	this.pageDocument.next(this.pageDocumentObject);
  }
  
  setShowCheckRequestAlert () {
	this.pageDocumentObject.showCheckRequestAlert = true;
	this.pageDocument.next(this.pageDocumentObject);
  }
  
  hideCheckRequestAlert () {
	this.pageDocumentObject.showCheckRequestAlert = false;
	this.pageDocument.next(this.pageDocumentObject);
  }
  
  setPageTitle (title) {
	if (title == '') {
		title = this.defaultTitle;
	} else {
		title = title + ' - ' + this.configService.get('system_name');
	}
	
	this.pageDocumentObject.title = title;
	this.pageDocument.next(this.pageDocumentObject);
  }
  
  setPageDescription (description) {
	if (description == '') {
		description = this.defaultDescription;
	}
	
	this.pageDocumentObject.description = description;
	this.pageDocument.next(this.pageDocumentObject);
  }
  
  setCurrentAuthor (authorName) {
	this.currentAuthor.next({name: authorName});
  }
  
  setDefaultAuthor () {
	this.currentAuthor.next({name: this.configService.get('default_author') });  
  }
  
  setDefaultTitle (title) {
	  this.defaultTitle = title;
  }
  
  setDefaultDescription (description) {
	  this.defaultDescription = description;
  }
  
  setDefaultMeta () {
	  this.setPageTitle(this.defaultTitle);
	  this.setPageDescription(this.defaultDescription);
  }
  
  getActivities(currentUserId): Observable<any> {
	let self = this;
  	return <any>this.apiConnectionService.read('userfiles/'+ currentUserId +'').then(function (data) {
		self.activities.next({activities: data});
  	}).catch(function (data) {
  		self.activities.next({});
  	});
  }
  
  checkToken () {
	let self = this;
	return new Promise(function(resolve, reject) 
	{
		try {
			let search = location.hash.substring(1);
			let params = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');

			if (params['loginToken']) {
				self.loginWithHash(params['loginToken']).then(function () {
					resolve(true);
				}).catch(function (error) {
				});
			} else {
				resolve(true);
			}
		} catch (e) {
			resolve(true);
		}
	});
  }
    
  async loginWithHash (hash) {
	let self = this;
  	return <any>this.apiConnectionService.read('users/loginByToken/'+hash+'').then(function (data) {
		self.apiConnectionService.setAccessToken(data['accessToken']);
		self.apiConnectionService.setRefreshToken(data['refreshToken']);
		
  	}).catch(function (data) {
		window.location.hash = '';
		window.location.reload();  		
  	});	  
  }

  getCurrentOrganisation () {
  	let self = this;
  	return self.apiConnectionService.read('organisations/info').then(function (data) {
  		self.currentOrganisation.next(data);
  	}).catch(function (data) {
  		self.currentOrganisation.next({});
  	});
  }  
  
  isSsoLoggedIn() {
    return true;
	let ssoQuery = 'https://ssoquery.aselect.entree.kennisnet.nl/openaselect/sso/ssoquery?response_url=' + this.configService.get('front_url') + '.nl&format=json';
	  
	let ssoCheck = sessionStorage.getItem('ssoCheck');
	if (ssoCheck == '1') {
		return true;
	}
	let self = this;
	var xhr = new XMLHttpRequest();
	xhr.open("GET", ssoQuery, true);
	xhr.withCredentials = true;
	xhr.onreadystatechange = function () {
		if (xhr.readyState === 4) {
		   if (xhr.status === 200 && JSON.parse(xhr.responseText)['result'] === 'true') {
				self.addToast('sso-toast', 'Login', 'login');
		   } else {
		   }
		}
	};
	xhr.ontimeout = function () {
		console.log('Niet ingelogd');
	};
	xhr.send();
	 
	sessionStorage.setItem('ssoCheck', '1');
  }

  addToast (id, content, type, data = '')
  {
	  this.toastList.push({
		  'id': id,
		  'content': content,
		  'type' : type,
		  'data' : data
	  });

	  this.toastObservable.next(this.toastList);
  }

  removeToast (id) 
  {
	this.toastList = this.toastList.filter(item => item['id'] !== id);
	this.toastObservable.next(this.toastList);
  }

}
